// CartService.js
export const getCartItems = () => {
  const items = localStorage.getItem("cartItems");
  return items ? JSON.parse(items) : [];
};

export const addToCart = (item) => {
  const items = getCartItems();
  items.push(item);
  localStorage.setItem("cartItems", JSON.stringify(items));
};

export const getCartCount = () => {
  return getCartItems().length;
};
export const clearCart = () => {
  localStorage.removeItem("cartItems");
};

